import React from 'react'
import Footer from '../components/footerComponent/footer'
import MyStudents from '../components/teacherComponent/myStudentsComponent'
import Header from '../components/headerComponent/header'
import {Layout} from 'antd';

export default function MyStudentsPage() {
    return (
        <Layout>
            <Header/>
            <MyStudents/>
            <Footer/>
        </Layout>
    );
};